export const modalMixin = {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ref: 'modal',
      isActive: this.active,
    }
  },
  watch: {
    active(value) {
      this.isActive = value
    },
  },
  mounted() {
    document.addEventListener('keyup', this.keyPressEsc)
  },
  destroyed() {
    document.body.style.overflow = ''
  },
  methods: {
    openModal() {
      this.isActive = true
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.isActive = false
      document.body.style.overflow = ''
    },
    keyPressEsc(event) {
      // Key press event to hide on ESC.
      if (event.keyCode === 27) {
        this.closeModal()
      }
    },
  },
}
